let authStorePromise = null

const getAuthStore = async () => {
  if (!authStorePromise) {
    authStorePromise = import('../zustand/authentication/use-auth-store').then(
      ({ useAuthStore }) => useAuthStore
    )
  }

  return authStorePromise
}

export default function tokenExpiredMiddleware() {
  return (dispatch) => (action) => {
    if (/_ERROR$/.test(action.type)) {
      if (
        action.error &&
        action.error.response &&
        action.error.response.status === 401
      ) {
        if (
          action.error.response.data &&
          action.error.response.data.error === 'invalid_token' &&
          action.error.response.data.error_description.includes(
            'Access token expired:'
          )
        ) {
          getAuthStore().then((authStore) => {
            authStore.getState().setExpiredToken(true)
          })
        }
      }
    }
    dispatch(action)
  }
}
